<template>
  <div class="page flex-col">
    <div class="main-container">
      <!-- 左侧边栏 -->
      <div class="sidebar">
        <div class="filter-section">
          <div style="
              display: flex;
              align-items: center;
              justify-content: flex-start;
              margin-top: -10px;
            ">
            <img style="width: 52px; height: 44px; flex-shrink: 0" src="./assets/img/Union.svg" alt="人才库logo" />
            <span class="rcktext">人才库</span>
          </div>
          <div class="filter-title" style="margin-top: 30px; margin-bottom: 20px;">筛选条件</div>

          <!-- 岗位类别 - 移到最上方 -->
          <div class="filter-group">
            <div class="group-title">岗位名称</div>
            <div class="checkbox-group">
              <label class="checkbox-item" v-for="category in categories" :key="category.id">
                <input type="radio" name="jobCategory" :value="category.id" v-model="selectedJobCategory" @change="handleFilterChange" @click="handleJobCategoryToggle(category.id)" />
                <span class="category-name-tooltip" :title="category.name" :data-full-text="category.name"
                  @mouseenter="showTooltip($event, category.name)" @mouseleave="hideTooltip()">
                  {{ truncateText(category.name, 5) }}
                </span>
              </label>
            </div>
          </div>




          <!-- 面试时间 -->
          <div class="filter-group">
            <div class="group-title">面试时间</div>
            <div class="checkbox-group">
              <label class="checkbox-item" v-for="time in interviewTimeOptions" :key="time.value">
                <input type="radio" name="interviewTime" :value="time.value" v-model="selectedInterviewTime" @change="handleFilterChange" @click="handleInterviewTimeToggle(time.value)" />
                <span>{{ time.label }}</span>
              </label>
            </div>
          </div>



          <!-- 学历 -->
          <div class="filter-group">
            <div class="group-title">学历</div>
            <div class="checkbox-group">
              <label class="checkbox-item">
                <input type="checkbox" v-model="educationFilters.college" @change="handleFilterChange" />
                <span>专科及以下</span>
              </label>
              <label class="checkbox-item">
                <input type="checkbox" v-model="educationFilters.bachelor" @change="handleFilterChange" />
                <span>本科</span>
              </label>
              <label class="checkbox-item">
                <input type="checkbox" v-model="educationFilters.master" @change="handleFilterChange" />
                <span>硕士</span>
              </label>
              <label class="checkbox-item">
                <input type="checkbox" v-model="educationFilters.phd" @change="handleFilterChange" />
                <span>博士</span>
              </label>
            </div>
          </div>

          <!-- 工作性质 -->
          <div class="filter-group">
            <div class="group-title">工作性质</div>
            <div class="checkbox-group">
              <label class="checkbox-item" v-for="nature in workNatureOptions" :key="nature.value">
                <input type="radio" name="workNature" :value="nature.value" v-model="selectedWorkNature" @change="handleFilterChange" @click="handleWorkNatureToggle(nature.value)">
                <span>{{ nature.label }}</span>
              </label>
            </div>
          </div>

        </div>
      </div>

      <!--主内容区 -->
      <div class="content-body">
        <!-- 动态分类标签 -->
        <div class="top-bar">
          <div class="category-tags">
            <div class="category-tag" :class="{ active: currentCategoryId === 'all' }"
              @click="handleCategoryChange('all')">
              全部
            </div>
            <div class="category-tag" :class="{ active: currentCategoryId === 'myFavorites' }"
              @click="handleCategoryChange('myFavorites')">
              我的收藏
            </div>
            <div class="category-tag" :class="{ active: currentCategoryId === 'viewed' }"
              @click="handleCategoryChange('viewed')">
              看过的人
            </div>
            <div class="category-tag" :class="{ active: currentCategoryId === 'unviewed' }"
              @click="handleCategoryChange('unviewed')">
              未看的人
            </div>
          </div>
        </div>

        <div class="search-bar">
          <input type="text" class="search-input" placeholder="搜索候选人" v-model="searchQuery"
            @keyup.enter="handleSearch" />
          <div class="search-icon-container" @click="handleSearch">
            <div class="search-icon">
              <img src="./assets/img/search.png" class="search-icon-img" alt="搜索图标" />
            </div>
          </div>
        </div>

        <!-- 加载指示器 -->
        <div v-if="loading" class="loading-indicator">
          <div class="loading-content">
            <div class="loading-dots">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
            </div>
            <span class="loading-text">正在加载候选人数据...</span>
          </div>
        </div>

        <div v-else-if="candidates.length === 0 && !loading" class="no-data">
          <div class="no-data-content">
            <i class="fa fa-user-o"></i>
            <span>暂无候选人</span>
          </div>
        </div>

        <!-- 候选人列表 -->
        <div v-if="candidates.length > 0" class="candidate-list waterfall-container">
          <div class="candidate-card waterfall-item" v-for="(candidate, index) in filteredCandidates"
            :key="candidate.id || index" :style="{ animationDelay: `${index * 0.1}s` }"
            @click="viewCandidate(candidate.id)">

            <!-- 候选人信息区域 -->
            <div class="candidate-content">
              <div class="candidate-header">
                <div class="candidate-avatar">
                  <Avatar :src="getAvatarByGender(candidate)" :char="candidate.name" :size="60" />
                </div>
                <div class="candidate-info">
                  <div class="candidate-name">
                    <span class="name-text">{{ candidate.name || "未知姓名" }}</span>
                    <div class="action-buttons">
                      <img v-if="Boolean(candidate.is_collected)" style="width: 28px; height: 28px; cursor: pointer"
                        src="./assets/img/noun-star.png" alt="已收藏" @click.stop="toggleCollect(candidate)" />
                      <svg v-else style="width: 18px; height: 18px; cursor: pointer" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" @click.stop="toggleCollect(candidate)">
                        <path d="M5.85186 19.7265C5.0101 20.2629 3.90934 19.9854 3.39808 19.1121C3.15571 18.6975 3.08039 18.2023 3.18808 17.7316L4.27759 12.9663C4.29057 12.9109 4.28866 12.8528 4.27206 12.7984C4.25547 12.7439 4.22481 12.6951 4.18334 12.6571L0.617042 9.46998C-0.123718 8.80845 -0.209219 7.65154 0.42404 6.88027C0.574721 6.69627 0.759453 6.5447 0.967567 6.43432C1.17568 6.32395 1.40305 6.25695 1.63656 6.23721L6.31687 5.84619C6.41887 5.83747 6.51012 5.7685 6.55187 5.66363L8.35515 1.14037C8.7309 0.198075 9.77592 -0.251917 10.6877 0.143717C11.1225 0.333248 11.4666 0.691547 11.6447 1.14037L13.448 5.66337C13.4897 5.7685 13.581 5.83773 13.683 5.84619L18.3638 6.23746C19.3453 6.31951 20.0721 7.21001 19.9943 8.22102C19.9578 8.70349 19.7383 9.15205 19.383 9.47049L15.8167 12.6576C15.7337 12.7317 15.6962 12.8517 15.7225 12.9666L16.812 17.7319C17.0375 18.7178 16.452 19.7111 15.4962 19.9488C15.2684 20.0055 15.0318 20.0151 14.8003 19.9769C14.5688 19.9388 14.3471 19.8538 14.148 19.7267L10.1407 17.1729C10.0985 17.1458 10.0497 17.1314 9.99992 17.1314C9.95012 17.1314 9.90134 17.1458 9.85917 17.1729L5.85186 19.7265ZM10.9327 15.866L14.94 18.4198C15.0015 18.4588 15.074 18.4709 15.1427 18.4537C15.293 18.4162 15.3902 18.2511 15.352 18.0829L14.2625 13.3176C14.1872 12.9898 14.2004 12.6471 14.3006 12.3264C14.4009 12.0056 14.5844 11.719 14.8315 11.4971L18.3978 8.31025C18.456 8.2582 18.4928 8.18256 18.4993 8.1C18.5125 7.92846 18.394 7.78334 18.242 7.77077L13.5612 7.37924C13.2332 7.351 12.9193 7.2301 12.6542 7.02996C12.3892 6.82981 12.1834 6.55825 12.0597 6.24541L10.2564 1.72241C10.2282 1.64974 10.1731 1.59148 10.1032 1.56036C9.96492 1.50036 9.80492 1.56933 9.74392 1.72241L7.94039 6.24541C7.81671 6.55825 7.61091 6.82981 7.34586 7.02996C7.08081 7.2301 6.76686 7.351 6.43887 7.37924L1.75831 7.77077C1.7222 7.774 1.68708 7.78454 1.65498 7.8018C1.62288 7.81905 1.59444 7.84267 1.57131 7.87128C1.5203 7.93446 1.49508 8.01541 1.5009 8.09721C1.50672 8.17901 1.54314 8.25534 1.60256 8.31025L5.16885 11.4974C5.41596 11.7192 5.59948 12.0059 5.69973 12.3266C5.79998 12.6473 5.81316 12.99 5.73786 13.3179L4.64835 18.0829C4.62972 18.1638 4.64245 18.2489 4.68385 18.3203C4.7656 18.4596 4.93185 18.5014 5.06035 18.4196L9.06791 15.866C9.34773 15.6874 9.67072 15.5928 10.0003 15.5928C10.3299 15.5928 10.6529 15.6874 10.9327 15.866Z" fill="url(#paint0_linear_5390_13170)"/>
                        <defs>
                          <linearGradient id="paint0_linear_5390_13170" x1="0" y1="10" x2="20" y2="10" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#62AFFF"/>
                            <stop offset="1" stop-color="#9C41FF"/>
                          </linearGradient>
                        </defs>
                      </svg>
                      <svg style="width: 18px; height: 18px; cursor: pointer" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" @click.stop="sendMessage(candidate)">
                        <path d="M10 0C12.6522 0 15.1957 1.05357 17.0711 2.92893C18.9464 4.8043 20 7.34784 20 10C20 12.6522 18.9464 15.1957 17.0711 17.0711C15.1957 18.9464 12.6522 20 10 20H0.907692C0.666957 20 0.436082 19.9044 0.265857 19.7341C0.0956316 19.5639 0 19.333 0 19.0923V10C0 7.34784 1.05357 4.8043 2.92893 2.92893C4.8043 1.05357 7.34784 0 10 0ZM10 13.6369H5.45333L5.29026 13.6523C5.07078 13.697 4.8755 13.8211 4.74182 14.0008C4.60815 14.1805 4.54547 14.4032 4.56579 14.6263C4.58612 14.8494 4.68802 15.0571 4.85197 15.2097C5.01593 15.3623 5.23042 15.449 5.45436 15.4533H10L10.1631 15.4379C10.3815 15.3923 10.5755 15.2681 10.7083 15.0887C10.8411 14.9094 10.9033 14.6875 10.8832 14.4653C10.8631 14.2431 10.762 14.036 10.5991 13.8835C10.4363 13.7309 10.2231 13.6436 10 13.6379V13.6369ZM13.6369 10H5.45436L5.29026 10.0154C5.06654 10.0556 4.86603 10.1782 4.72828 10.3591C4.59053 10.5399 4.52555 10.7657 4.54615 10.9921C4.56675 11.2185 4.67145 11.4289 4.83957 11.5819C5.0077 11.7349 5.22706 11.8193 5.45436 11.8185H13.6369L13.8 11.8031C14.0236 11.7628 14.2241 11.6403 14.3618 11.4596C14.4995 11.2789 14.5646 11.0532 14.5441 10.8269C14.5237 10.6006 14.4192 10.3902 14.2512 10.2371C14.0833 10.084 13.8641 9.99945 13.6369 10ZM13.6369 6.36308H5.45436L5.29026 6.37846C5.06654 6.4187 4.86603 6.54132 4.72828 6.72214C4.59053 6.90295 4.52555 7.12882 4.54615 7.35519C4.56675 7.58156 4.67145 7.79199 4.83957 7.94496C5.0077 8.09794 5.22706 8.18235 5.45436 8.18154H13.6369L13.8 8.16615C14.0236 8.12593 14.2241 8.00338 14.3618 7.82268C14.4995 7.64198 14.5646 7.41623 14.5441 7.18994C14.5237 6.96365 14.4192 6.75323 14.2512 6.60018C14.0833 6.44712 13.8641 6.36253 13.6369 6.36308Z" fill="url(#paint0_linear_5390_13171)"/>
                        <defs>
                          <linearGradient id="paint0_linear_5390_13171" x1="0" y1="10" x2="20" y2="10" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#62AFFF"/>
                            <stop offset="1" stop-color="#9C41FF"/>
                          </linearGradient>
                        </defs>
                      </svg>
                    </div>
                  </div>
                  <div class="candidate-basic">
                    {{ candidate.age || "未知" }}岁 | {{ candidate.school || "未知学校" }} | {{
                      getEducationLabel(candidate.education) }} | {{ formatWorkYears(candidate.work_years) }}
                  </div>
                </div>
              </div>

              <div class="candidate-details">
                <div class="candidate-tags">
                  <div class="tag" >
                    {{ candidate.job_category || "未知类别" }}
                  </div>
                  <div class="tag">
                    {{ WORK_NATURE_MAP.get(candidate.work_nature) }}
                  </div>

                </div>

                <div class="candidate-info-grid">
                  <div class="candidate-position">
                    <div class="position-label">面试岗位：</div>
                    <div class="position-value">
                      {{ candidate.interview_position || "未知岗位" }}
                    </div>
                  </div>

                  <div class="candidate-time">
                    <div class="time-label">面试时间：</div>
                    <div class="time-value">
                      {{ formatTime(candidate.create_time) }}
                    </div>
                  </div>

                  <div class="candidate-duration">
                    <div class="duration-label">面试时长：</div>
                    <div class="duration-value">
                      {{
                        candidate.interview_duration
                          ? `${candidate.interview_duration}分钟`
                          : "未知"
                      }}
                    </div>
                  </div>
                </div>

                <!-- 评分图片 -->
                <div class="score-image">
                  <img src="./assets/img/score.png" alt="评分" />
                </div>
                <div class="score-text">
                  {{ candidate.evaluation_score || 0 }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 无限滚动加载提示 -->
        <div class="infinite-scroll-indicator" v-if="hasMoreData && candidates.length > 0">
          <div v-if="loadingMore" class="loading-more-content">
            <div class="loading-dots">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
            </div>
            <span class="loading-text">正在加载更多候选人...</span>
          </div>
        </div>
      </div>
    </div>
    <Profile @changePopup="handlePopupChange" v-if="currentPopup === 'profile'" />

    <!-- 全局tooltip -->
    <div v-if="tooltipVisible" class="global-tooltip" :style="{ left: tooltipX + 'px', top: tooltipY + 'px' }">
      {{ tooltipText }}
    </div>
  </div>
</template>


<script>
import { mapState } from "vuex";
import { getPositionList } from "@/api/position";
import Avatar from "@/components/Avatar.vue";
import Profile from '@/components/Profile/index.vue';
import { getToken } from "@/store/local/auth";
import { getTalentList, favoriteTalent } from "@/api/talent";
import { WORK_NATURE_OPTIONS, WORK_NATURE_MAP, INTERVIEW_TIME_OPTIONS, getEducationLabel } from "@/utils/constants";


export default {
  components: {
    Profile,
    Avatar,
  },
  data() {
    return {
      currentPopup: null,
      tooltipVisible: false,
      tooltipText: '',
      tooltipX: 0,
      tooltipY: 0,
      defaultAvatar: require("./assets/img/default-avatar.png"), // 默认头像
      maleAvatar: require("./assets/img/male.png"), // 默认头像
      femaleAvatar: require("./assets/img/female.png"), // 默认头像
      searchQuery: "",
      loading: false,
      loadingMore: false,
      categories: [], // 存储动态获取的分类列表（包含id和name）
      currentCategoryId: null, // 当前选中的分类ID

      // 瀑布流相关
      pageSize: 8,          // 每次加载条数
      currentPage: 1,       // 当前页码
      hasMoreData: true,    // 是否还有更多数据
      totalCount: 0,        // 总数据条数

      // 无限滚动相关
      scrollHandler: null,  // 滚动事件处理器
      scrollThrottle: null, // 滚动节流器

      // 接口返回的候选人数据
      candidates: [],
      // 当前选中的收藏状态筛选
      isCollected: null, // null-不筛选，true-已收藏，false-未收藏
      // 当前选中的查看状态筛选
      viewStatus: null, // null-不筛选，0-未查看，1-已查看

      // 单选面试时间
      selectedInterviewTime: null,
      // 需要修改
      educationFilters: {
        college: false, // 0-专科及以下
        bachelor: false, // 1-本科
        master: false, // 2-硕士
        phd: false, // 3-博士
      },
      workNatureFilters: {
        intern: false, // 0-实习生
        partTime: false, // 1-兼职
        fullTime: false, // 2-全职
      },
      // 工作性质选项常量
      workNatureOptions: WORK_NATURE_OPTIONS,
      WORK_NATURE_MAP: WORK_NATURE_MAP,
      // 面试时间选项常量
      interviewTimeOptions: INTERVIEW_TIME_OPTIONS,
      // 单选工作性质
      selectedWorkNature: null,
      selectedWorkNatures: [],
      // 单选岗位类别
      selectedJobCategory: null,
      jobCategoryFilters: {},
      jobId: ''
    };
  },
  computed: {
    ...mapState("user", ["avatar"]),
    filteredCandidates() {
      if (!this.searchQuery) return this.candidates;
      const query = this.searchQuery.toLowerCase();
      return this.candidates.filter(
        (candidate) =>
          candidate.name?.toLowerCase().includes(query) ||
          candidate.mobile?.includes(query) ||
          candidate.school?.toLowerCase().includes(query) ||
          candidate.interviewPosition?.toLowerCase().includes(query) ||
          candidate.jobCategory?.toLowerCase().includes(query)
      );
    },
    hasCategories() {
      return this.categories.length > 0;
    }
  },
  async created() {
    // 检查登录状态
    if (!getToken()) {
      this.$message.warning("您尚未登录或登录已过期，请重新登录");
      this.$router.push("/store/entry");
      return;
    }
    // 先获取分类列表
    await this.fetchCategories();
  },

  mounted() {
    // 添加滚动监听器
    this.addScrollListener();
  },

  beforeDestroy() {
    // 移除滚动监听器
    this.removeScrollListener();
  },

  destroyed() {
    // 确保在组件销毁时清理
    this.removeScrollListener();
  },
  methods: {
    getEducationLabel,
    // 截断文本并添加省略号
    truncateText(text, maxLength) {
      if (!text) return '';
      if (text.length <= maxLength) return text;
      return text.substring(0, maxLength) + '...';
    },

    // 显示tooltip
    showTooltip(event, text) {
      const rect = event.target.getBoundingClientRect();
      this.tooltipText = text;
      this.tooltipX = rect.right + 12; // 在元素右侧12px处
      this.tooltipY = rect.top + rect.height / 2; // 垂直居中
      this.tooltipVisible = true;
    },

    // 隐藏tooltip
    hideTooltip() {
      this.tooltipVisible = false;
    },

    // 岗位类别切换处理 - 支持取消选中
    handleJobCategoryToggle(categoryId) {
      if (this.selectedJobCategory === categoryId) {
        // 如果点击的是已选中的，则取消选中
        this.selectedJobCategory = null;
        this.handleFilterChange();
      }
    },

    // 面试时间切换处理 - 支持取消选中
    handleInterviewTimeToggle(timeValue) {
      if (this.selectedInterviewTime === timeValue) {
        // 如果点击的是已选中的，则取消选中
        this.selectedInterviewTime = null;
        this.handleFilterChange();
      }
    },

    // 工作性质切换处理 - 支持取消选中
    handleWorkNatureToggle(natureValue) {
      if (this.selectedWorkNature === natureValue) {
        // 如果点击的是已选中的，则取消选中
        this.selectedWorkNature = null;
        this.handleFilterChange();
      }
    },

    handlePopupChange(popupType) {
      this.currentPopup = popupType;
    },
    // 关闭弹窗
    closePopup() {
      this.currentPopup = null;
    },
    // 获取分类列表 - 包含id和name
    async fetchCategories() {
      try {
        // 调用API获取分类列表
        const response = await getPositionList({ status: 1});

        if (response.data.code === 1) {
          // 使用Map确保分类唯一，保存id和name
          const categoryMap = new Map();

          // 遍历职位列表提取id和category字段
          response.data.data.lists.forEach((item) => {
            if (item.id && item.category && !categoryMap.has(item.id)) {
              categoryMap.set(item.id, {
                id: item.id,
                name: item.title
              });
            }
          });

          // 转换为数组并赋值
          this.categories = Array.from(categoryMap.values());

          // 初始化jobCategoryFilters
         
          const jobId = this.$route.params.jobId;
          if (jobId) {
            this.selectedJobCategory = parseInt(jobId);
            this.handleFilterChange()
          } else {
            this.selectedJobCategory = null;
          }

          // 默认选中"全部"分类
          this.currentCategoryId = 'all';
          this.fetchTalentList();
        } else {
          this.$message.error(
            "获取分类列表失败: " + (response.data.msg || "未知错误")
          );
          // 出错时使用默认分类
          this.categories = [
            { id: 1, name: "前端" },
            { id: 2, name: "后端" },
            { id: 3, name: "产品" },
            { id: 4, name: "算法/大模型" },
            { id: 5, name: "互联网" }
          ];

          // 初始化jobCategoryFilters
          this.selectedJobCategory = null;

          // 默认选中"全部"分类
          this.currentCategoryId = 'all';
          this.fetchTalentList();
        }
      } catch (error) {
        console.error("获取分类列表出错:", error);
        this.$message.error("获取分类列表失败，请稍后重试");
        // 出错时使用默认分类
        this.categories = [
          { id: 1, name: "前端" },
          { id: 2, name: "后端" },
          { id: 3, name: "产品" },
          { id: 4, name: "算法/大模型" },
          { id: 5, name: "互联网" }
        ];

        // 初始化jobCategoryFilters
        this.selectedJobCategory = null;

        // 默认选中"全部"分类
        this.currentCategoryId = 'all';
        this.fetchTalentList();
      }
    },

    // 初始化岗位类别筛选器（已废弃，改为单选）
    initializeJobCategoryFilters() {
      this.jobCategoryFilters = {};
      this.categories.forEach(category => {
        this.jobCategoryFilters[category.id] = false;
      });
    },

    // 处理筛选条件变化
    handleFilterChange() {
      this.resetPagination();
      this.fetchTalentList();
    },


    // 重置分页状态
    resetPagination() {
      this.candidates = [];
      this.currentPage = 1;
      this.hasMoreData = true;
      this.totalCount = 0;
    },

    buildRequestParams() {
      // 处理面试时间参数（单选）
      let interviewTime = null;
      if (this.selectedInterviewTime !== null) {
        interviewTime = parseInt(this.selectedInterviewTime);
      }

      // 处理学历参数（多选）
      const education = [];
      if (this.educationFilters.college) education.push(0);
      if (this.educationFilters.bachelor) education.push(1);
      if (this.educationFilters.master) education.push(2);
      if (this.educationFilters.phd) education.push(3);

      // 处理工作性质参数（单选）
      let workNature = null;
      if (this.selectedWorkNature !== null) {
        workNature = [parseInt(this.selectedWorkNature)];
      }

      // 处理岗位类别参数（单选）
      const jobId = [];
      if (this.selectedJobCategory !== null) {
        jobId.push(parseInt(this.selectedJobCategory));
      }

      // 构建参数对象 - 瀑布流分页参数
      const params = {
        page_no: this.currentPage, // 使用当前页码
        page_size: this.pageSize,
        keywords: this.searchQuery || undefined,
      };

      // 添加选中的岗位ID - 只有非特殊选项才发送jobId参数
      if (this.currentCategoryId !== null &&
        this.currentCategoryId !== 'all' &&
        this.currentCategoryId !== 'myFavorites' &&
        this.currentCategoryId !== 'viewed' &&
        this.currentCategoryId !== 'unviewed') {
        params.jobId = this.currentCategoryId;
      }

      // 仅添加有值的参数
      if (interviewTime !== null) params.interviewTime = interviewTime;
      if (education.length) params.education = education;
      if (workNature !== null && workNature.length > 0) params.workNature = workNature;
      if (jobId.length) params.jobId = jobId;
      if (this.isCollected !== null) params.isCollected = this.isCollected ? true : false;
      if (this.viewStatus !== null) params.viewStatus = this.viewStatus;



      return params;
    },

    // 调用API获取人才列表
    async fetchTalentList() {
      // 如果没有选中的分类，不加载数据
      if (this.currentCategoryId === null) {
        return;
      }

      try {
        this.loading = true;
        const params = this.buildRequestParams();
        console.log('请求参数:', params); // 调试信息
        const response = await getTalentList(params);

        if (response.data.code === 1) {
          const newCandidates = response.data.data.lists || [];
          const totalCount = response.data.data.count || 0;

          // 重置数据（第一页）
          this.candidates = newCandidates;
          this.totalCount = totalCount;
          this.currentPage = 1;

          // 判断是否还有更多数据
          this.hasMoreData = this.candidates.length < this.totalCount;
        } else {
          this.$message.error(
            "获取人才列表失败: " + (response.msg || "未知错误")
          );
          this.candidates = [];
        }
      } catch (error) {
        console.error("获取人才列表出错:", error);
        this.$message.error("获取人才列表失败，请稍后重试");
        this.candidates = [];
      } finally {
        this.loading = false;
      }
    },

    // 添加滚动监听器
    addScrollListener() {
      this.scrollHandler = this.handleScroll.bind(this);

      // 监听window滚动
      window.addEventListener('scroll', this.scrollHandler, { passive: true });

      // 也监听content-body容器的滚动
      this.$nextTick(() => {
        const contentBody = document.querySelector('.content-body');
        if (contentBody) {
          contentBody.addEventListener('scroll', this.scrollHandler, { passive: true });
        }
      });
    },

    // 移除滚动监听器
    removeScrollListener() {
      if (this.scrollHandler) {
        window.removeEventListener('scroll', this.scrollHandler);

        // 也移除content-body容器的监听器
        const contentBody = document.querySelector('.content-body');
        if (contentBody) {
          contentBody.removeEventListener('scroll', this.scrollHandler);
        }
      }
    },

    // 处理滚动事件
    handleScroll() {
      // 节流处理，避免频繁触发
      if (this.scrollThrottle) return;

      this.scrollThrottle = setTimeout(() => {
        this.scrollThrottle = null;
        this.checkScrollPosition();
      }, 100);
    },

    // 检查滚动位置
    checkScrollPosition() {
      if (this.loadingMore || !this.hasMoreData) return;

      // 检查window滚动
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      // 检查content-body容器滚动
      const contentBody = document.querySelector('.content-body');
      let containerScrollTop = 0;
      let containerHeight = 0;
      let containerScrollHeight = 0;

      if (contentBody) {
        containerScrollTop = contentBody.scrollTop;
        containerHeight = contentBody.clientHeight;
        containerScrollHeight = contentBody.scrollHeight;
      }

      // 当滚动到距离底部50px时触发加载
      const shouldLoad = (scrollTop + windowHeight >= documentHeight - 50) ||
        (containerScrollTop + containerHeight >= containerScrollHeight - 50);

      if (shouldLoad) {
        this.loadMore();
      }
    },

    // 加载更多数据
    async loadMore() {
      if (this.loadingMore || !this.hasMoreData) return;

      try {
        this.loadingMore = true;
        // 增加页码
        this.currentPage += 1;
        const params = this.buildRequestParams();
        const response = await getTalentList(params);

        if (response.data.code === 1) {
          const newCandidates = response.data.data.lists || [];

          // 追加新数据
          this.candidates = [...this.candidates, ...newCandidates];

          // 根据总数据量判断是否还有更多数据
          this.hasMoreData = this.candidates.length < this.totalCount;
        } else {
          // 如果请求失败，回退页码
          this.currentPage -= 1;
          this.$message.error("加载更多失败: " + (response.msg || "未知错误"));
        }
      } catch (error) {
        // 如果请求失败，回退页码
        this.currentPage -= 1;
        console.error("加载更多出错:", error);
        this.$message.error("加载更多失败，请稍后重试");
      } finally {
        this.loadingMore = false;
      }
    },

    // 搜索处理
    handleSearch() {
      this.resetPagination();
      this.fetchTalentList();
    },

    // 分类筛选处理 - 接收id
    handleCategoryChange(id) {
      this.currentCategoryId = id;

      // 重置相关筛选条件
      this.resetJobCategoryFilters();

      // 处理收藏筛选
      if (id === 'myFavorites') {
        this.isCollected = 1; // 设置为已收藏
        this.viewStatus = null; // 重置查看状态筛选
        console.log('点击我的收藏，设置 isCollected = 1'); // 调试信息
      } else {
        this.isCollected = null; // 重置收藏筛选
      }

      // 处理查看状态筛选
      if (id === 'viewed') {
        this.viewStatus = 1; // 设置为已查看
        this.isCollected = null; // 重置收藏筛选
      } else if (id === 'unviewed') {
        this.viewStatus = 0; // 设置为未查看
        this.isCollected = null; // 重置收藏筛选
      } else if (id !== 'myFavorites') {
        this.viewStatus = null; // 重置查看状态筛选
      }

      this.resetPagination();
      this.fetchTalentList();
    },

    // 重置岗位类别筛选
    resetJobCategoryFilters() {
      this.selectedJobCategory = null;
    },

    // 重置所有筛选条件
    resetFilters() {
      // 重置单选筛选器
      this.selectedInterviewTime = null;
      this.selectedWorkNature = null;
      this.selectedJobCategory = null;
      
      // 重置多选筛选器
      Object.keys(this.educationFilters).forEach(
        (key) => (this.educationFilters[key] = false)
      );

      // 重置其他参数
      this.searchQuery = "";
      this.isCollected = null;
      this.viewStatus = null;

      // 重置为默认选中"全部"分类
      this.currentCategoryId = 'all';
      this.resetPagination();
      this.fetchTalentList();
    },

    // 查看候选人详情
    viewCandidate(id) {
      this.$router.push({
        name: "detail",
        params: { id },
      });
    },

    // 切换收藏状态
    async toggleCollect(candidate) {
      try {
        // 确保布尔值转换正确
        const currentStatus = Boolean(candidate.is_collected);
        const newStatus = !currentStatus;

        // 调用收藏接口
        const response = await favoriteTalent({
          id: candidate.user_id,
          isCollected: newStatus ? 1 : 0,
        });

        if (response.data.code === 1) {
          // 更新本地状态
          candidate.is_collected = newStatus;
          this.$message.success(newStatus ? "收藏成功" : "取消收藏成功");
        } else {
          this.$message.error(
            newStatus
              ? "收藏失败"
              : "取消收藏失败: " + (response.msg || "操作失败")
          );
        }
      } catch (error) {
        console.error("收藏操作失败:", error);
        this.$message.error("收藏操作失败，请稍后重试");
      }
    },

    // 发送消息
    sendMessage(candidate) {
      console.log("发送消息给候选人:", candidate);
      this.$router.push({
        name: "chating",
        query: { jobId: candidate.job_id, targetUserId: candidate.user_id },
      });
    },

    // 格式化时间戳为日期
    formatTime(timestamp) {
      if (!timestamp) return "未知时间";
      
      // 处理 Unix 时间戳（秒），需要转换为毫秒
      let convertedTimestamp;
      if (typeof timestamp === 'number' && timestamp < 10000000000) {
        // 秒时间戳，转换为毫秒
        convertedTimestamp = timestamp * 1000;
      } else {
        // 已经是毫秒时间戳或字符串
        convertedTimestamp = timestamp;
      }
      
      const date = new Date(convertedTimestamp);
      return `${date.getFullYear()}-${(date.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")} ${date
          .getHours()
          .toString()
          .padStart(2, "0")}:${date.getMinutes().toString().padStart(2, "0")}`;
    },


    // 格式化工作年限
    formatWorkYears(years) {
      if (years === undefined || years === null) return "未知经验";
      if (years === 0) return "应届生";
      if (years < 3) return `${years}年以内`;
      if (years < 5) return `3-${years}年`;
      return `${years}年以上`;
    },



    // 格式化工作性质
    formatWorkNature(nature) {
      return WORK_NATURE_MAP[nature] || "未知性质";
    },

    // 格式化性别
    formatGender(gender) {
      // 假设0-男，1-女，其他-未知
      return gender === 0 ? "male" : gender === 1 ? "female" : "male";
    },

    // 根据性别获取头像
    getAvatarByGender(candidate) {
      // 如果候选人有自定义头像，优先使用
      if (candidate.avatar) {
        return candidate.avatar;
      }

      // 根据性别选择默认头像
      if (candidate.gender === 0) {
        // 男性
        return this.maleAvatar;
      } else if (candidate.gender === 1) {
        // 女性
        return this.femaleAvatar;
      } else {
        // 性别为null或其他值，默认使用男性头像
        return this.maleAvatar;
      }
    },
  },
};
</script>
<style scoped lang="css" src="./assets/index.response.css" />
<style scoped lang="css" src="./assets/candidate.css" />
<style scoped>
/* 页面内不再放置头像，样式删除 */
/* 自定义样式 */
.left {
  flex: 0 0 20%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background: linear-gradient(180deg,
      rgba(177, 110, 249, 0.1) 0%,
      rgba(126, 180, 235, 0.1) 100%);
  border-radius: 26px;
  border: 1px solid #a47ff6;
  box-shadow: 4.32px 4.32px 4.32px 0px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(27.85px);
  margin-right: -1.5vw;
}

.div42 {
  color: #656587;
  font-family: "Afacad-Regular", sans-serif;
  font-size: 16px;
  font-weight: 400;
  margin-left: 20px;
}

.card-link {
  text-decoration: none;
  color: inherit;
}

.image5 {
  width: 100%;
  height: 60%;
  object-fit: cover;
  border-radius: 25.92px 25.92px 0 0;
}

.frame-1 {
  padding: 20px;
  overflow-y: auto;
  height: calc(100% - 80px);
}

.vector-1 {
  width: 100%;
  height: auto;
}

.div13 {
  color: #656587;
  font-family: "Afacad-Regular", sans-serif;
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 10px;
}

.div14 {
  color: #ffffff;
  text-align: center;
  font-family: "Afacad-Regular", sans-serif;
  font-size: 13px;
  font-weight: 400;
  text-decoration: none;
  line-height: 32px;
}

._1 {
  position: absolute;
  width: 13vw;
  min-width: 180px;
  max-width: 300px;
  height: auto;
  top: 3vh;
  left: 0;
  z-index: 0;
}

/* 模态框样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-container {
  height: 28vh;
  width: 22vw;
  background: rgba(255, 255, 255, 0.85);
  border-radius: 1vw;
  box-shadow: 0 0.5vw 2vw rgba(0, 0, 0, 0.1);
  padding: 1.5vw;
  backdrop-filter: blur(15px);
  border: 1px solid rgba(126, 180, 235, 0.3);
}

.modal-content {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.modal-title {
  font-size: 1.2vw;
  color: #444;
  margin-bottom: 1.5vh;
  text-align: center;
}

.modal-input {
  width: 90%;
  height: 3.5vh;
  border: none;
  border-radius: 0.5vw;
  padding: 0 1vw;
  margin-bottom: 2vh;
  font-size: 1vw;
  background: rgba(255, 255, 255, 0.8);
  border-bottom: 2px solid #7eb4eb;
  outline: none;
  text-align: center;
}

.modal-buttons {
  display: flex;
  justify-content: space-between;
  width: 80%;
  margin-top: 8vh;
}

.modal-btn {
  width: 7vw;
  height: 5vh;
  border: none;
  border-radius: 2vh;
  font-size: 0.9vw;
  cursor: pointer;
  transition: all 0.3s;
}

.confirm-btn {
  background: linear-gradient(90deg, #7eb4eb, #b16ef9);
  color: white;
}

.cancel-btn {
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid #ddd;
  color: #666;
}

.modal-btn:hover {
  transform: translateY(-0.2vh);
  box-shadow: 0 0.3vh 0.8vh rgba(0, 0, 0, 0.1);
}

.user-profile {
  display: flex;
  align-items: center;
  width: 100%;
  padding-left: 2vw;
}

.avatar {
  width: 3.5vw;
  height: 3.5vw;
  min-width: 3.5vw;
  margin-right: 0.1vw;
  border-radius: 50%;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  border-radius: 50%;
  display: block;
}

.username {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.history-card {
  border: 1px solid #7eb4eb !important;
  border-image: none !important;
}

.sidebar {
  border: none !important;
  border-radius: 0 !important;
  margin-left: 0 !important;
  padding-left: 0 !important;
  width: 20% !important;
}

.rcktext {
  font-family: Afacad;
  font-size: 24px;
  font-weight: 800;
  line-height: normal;
  background: var(--linear-2-paints, linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* 筛选按钮样式 */
.reset-btn,
.apply-btn {
  width: 80%;
  padding: 8px 0;
  margin: 10px auto;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  font-size: 14px;
  display: block;
}

.reset-btn {
  background-color: #f5f5f5;
  color: #666;
}

.apply-btn {
  background: linear-gradient(90deg, #7eb4eb, #b16ef9);
  color: white;
}

/* 网格布局样式 */
.waterfall-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  padding: 0 2vw;
  width: 100%;
}

/* 响应式设计 */
@media (max-width: 600px) {
  .waterfall-container {
    grid-template-columns: 1fr;
    gap: 12px;
  }
}

.waterfall-item {
  width: auto;
  min-width: 0;
  margin-bottom: 0;
}

/* 候选人内容区域 */
.candidate-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: flex-start;
}

/* 候选人头部样式 */
.candidate-header {
  display: flex;
  align-items: center;
}

.candidate-avatar {
  flex-shrink: 0;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.candidate-info {
  flex: 1;
  min-width: 0;
}

.candidate-name {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
}

.name-text {
  font-size: 15px;
  font-weight: 600;
  color: #656587;
  flex: 1;
  margin-right: 10px;
}

.action-buttons {
  display: flex;
  gap: 6px;
  align-items: center;
}

.action-buttons img {
  width: 28px !important;
  height: 28px !important;
  object-fit: contain !important;
  flex-shrink: 0 !important;
  display: block !important;
  cursor: pointer !important;
  transition: all 0.2s ease !important;
}

.action-buttons img:hover {
  transform: scale(1.1) !important;
  opacity: 0.8 !important;
}

.candidate-basic {
  font-size: 13px;
  color: #656587;
  line-height: 1.3;
  margin-bottom: 6px;
}

/* 标签样式优化 */
.candidate-tags {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  margin: 6px 0;
}

.tag {
  padding: 1px 4px;
  /*  background-color: rgba(177, 110, 249, 0.1); */
  border-radius: 3px;
  border: 1px solid;
  border-image: linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%) 1;
  font-size: 10px;
  color: #656587;
}

/* 候选人详情样式 */
.candidate-details {
  display: flex;
  flex-direction: column;
  gap: 6px;
  position: relative !important;
  flex: 1;
}

.candidate-info-grid {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.candidate-position,
.candidate-time,
.candidate-duration {
  display: flex;
  align-items: center;

  font-size: 12px;
}

.position-label,
.time-label,
.duration-label {
  color: #999;
  font-weight: 500;
  min-width: 50px;
}

.position-value,
.time-value,
.duration-value {
  color: #333;
  font-weight: 500;
}

/* 评分图片样式 */
.score-image {
  position: absolute !important;
  bottom: 4px !important;
  right: -10px !important;
  width: 150px !important;
  height: 150px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-sizing: border-box !important;
  z-index: 1 !important;
}

.score-image img {
  width: 100% !important;
  height: 100% !important;
  object-fit: contain !important;
  display: block !important;
}

.score-text {
  position: absolute !important;
  bottom: 34px !important;
  right: 60px !important;
  font-size: 52px !important;
  font-weight: 600 !important;
  background: linear-gradient(90deg, #B16EF9 0%, #7EB4EB 85.76%, #84ACED 100%) !important;
  background-clip: text !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  z-index: 11 !important;
  pointer-events: none !important;
}

/* 搜索框样式 */
.search-bar {
  border-radius: 0 !important;
  width: calc(100% - 4vw) !important;
  margin: 0 2vw 24px 2vw !important;
  box-sizing: border-box !important;
  display: flex !important;
  align-items: stretch !important;
  border: 1px solid #ddd !important;
  background: #fff !important;
  overflow: hidden !important;
}

.search-input {
  border: none !important;
  border-radius: 0 !important;
  padding: 8px 12px !important;
  font-size: 14px !important;
  outline: none !important;
  flex: 1 !important;
  box-sizing: border-box !important;
  background: transparent !important;
}

.search-input:focus {
  box-shadow: none !important;
}

.search-input:focus+.search-icon-container {
  background: #f8f9fa !important;
}

.search-icon-container {
  border: none !important;
  border-radius: 0 !important;
  background: #fff !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 8px 12px !important;
  cursor: pointer !important;
  transition: all 0.3s ease !important;
  border-left: 1px solid #ddd !important;
  min-height: 100% !important;
  box-sizing: border-box !important;
  line-height: 1 !important;
}

.search-icon-container:hover {
  background: #f8f9fa !important;
}

.search-icon {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
  height: 100% !important;
  line-height: 1 !important;
}

.search-icon-img {
  width: 16px !important;
  height: 16px !important;
  object-fit: contain !important;
  display: block !important;
  margin: auto !important;
}

/* 候选人卡片样式 */
.candidate-card {
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 16px;
  padding: 12px;
  background: var(--Linear, linear-gradient(321deg, rgba(255, 255, 255, 0.40) 2.06%, rgba(255, 255, 255, 0.72) 42.17%, rgba(255, 255, 255, 0.80) 99.08%));
  box-shadow: 1px 1px 10px 0 rgba(0, 0, 0, 0.05), 4px 4px 20px 0 rgba(0, 0, 0, 0.05);
  backdrop-filter: blur(15px);
  animation: cardFadeIn 0.6s ease forwards;
  opacity: 0;
  width: auto;
  min-width: 0;
  height: auto;
  min-height: 160px;
  display: flex;
  align-items: flex-start;
  gap: 15px;
  position: relative;
}

.candidate-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(177, 110, 249, 0.15);
  border-color: rgba(177, 110, 249, 0.3);
}

@keyframes cardFadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 头像默认图样式 - 确保完美比例 */
.candidate-avatar img {
  object-fit: cover;
  object-position: center;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  display: block;
}

.loading-indicator,
.no-data {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  width: 100%;
  border-radius: 16px;
  margin: 20px 0;
}

.loading-content,
.no-data-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  animation: fadeInUp 0.6s ease;
}

.loading-indicator .loading-text,
.no-data span {
  color: #656587;
  font-size: clamp(14px, 1.2vw, 18px);
  font-weight: 500;
  margin-top: 20px;
  letter-spacing: 0.5px;
}

.no-data .fa {
  color: #ddd;
  font-size: 48px;
}

/* 无限滚动指示器样式 */
.infinite-scroll-indicator {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px 0;
  width: 100%;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(177, 110, 249, 0.05) 100%);
  border-radius: 12px;
  margin: 20px 0;
  transition: all 0.3s ease;
}

.loading-more-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  animation: fadeInUp 0.5s ease;
}

.loading-text {
  color: #656587;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.5px;
}

/* 加载点动画 */
.loading-dots {
  display: flex;
  gap: 8px;
  align-items: center;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: linear-gradient(135deg, #7eb4eb, #b16ef9);
  animation: dotPulse 1.4s ease-in-out infinite both;
}

.dot:nth-child(1) {
  animation-delay: -0.32s;
}

.dot:nth-child(2) {
  animation-delay: -0.16s;
}

.dot:nth-child(3) {
  animation-delay: 0s;
}

@keyframes dotPulse {

  0%,
  80%,
  100% {
    transform: scale(0.8);
    opacity: 0.5;
  }

  40% {
    transform: scale(1.2);
    opacity: 1;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 悬停效果 */
.infinite-scroll-indicator:hover {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(177, 110, 249, 0.08) 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(177, 110, 249, 0.1);
}
</style>